<template>
  <div class="right-panel-multi-tabs">
    <MultiTabs
      :tabTitles="tabTitles"
      :defaultTabIndex="defaultTabIndex"
      closeable
      @onCloseButtonClicked="closePanel()"
    >
      <template #tab-0>
        <AIImprovePanel />
      </template>

      <template #tab-1>
        <AIEditPanel />
      </template>
    </MultiTabs>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import MultiTabs from '@/components/UI/MultiTabs.vue'
import AIEditPanel from '@/components-v2/presentation-editor/side-right/right-nav/AIEditPanel.vue'
import AIImprovePanel from '@/components-v2/presentation-editor/side-right/right-nav/AIImprovePanel.vue'

export default {
  components: {
    MultiTabs,
    AIEditPanel,
    AIImprovePanel,
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      isNewPresentation: (state) => state.isNewPresentation,
    }),
    ...mapGetters('slideType', ['isExcludedSlideTypesForImprovingSlideContent', 'isContentSlide']),
    ...mapGetters('docToSlideGenerator', ['docToSlideUniqueRequestId']),
    ...mapGetters(['hasSlideId', 'isDefaultSlide']), // getters/slideActive

    tabTitles() {
      return ['Improve Writing', 'Create']
    },

    isGeneratingDocToSlide() {
      return Boolean(this.docToSlideUniqueRequestId)
    },

    defaultTabIndex() {
      const isExcludedOrNewPresentation = this.isExcludedSlideTypesForImprovingSlideContent || this.isNewPresentation
      const isSlideInvalid = !this.hasSlideId || this.isDefaultSlide

      if (this.isGeneratingDocToSlide || isExcludedOrNewPresentation || isSlideInvalid) return 1
      return 0
    },
  },

  methods: {
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),

    closePanel() {
      this.setRightNavActiveTabAction('')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss-v2/variables.scss';

.right-panel-multi-tabs {
  @apply h-full;
  .multi-tabs {
    @apply rounded-lg my-3 mr-2 border border-base-30 overflow-hidden bg-base-0 relative;
    width: 384px;
    height: calc(100% - 1.5rem);
    box-shadow: 0px 10px 38px 0px #525F7F08;
    transform: scale(1); // to make settings-header fixed and follow this parent
  }
  &::v-deep {
    .multi-tabs__content {
      @apply h-full;
    }
    .aha-tabs {
      @apply fixed top-0 z-10 border-b border-base-30 bg-base-0;
      @apply px-4 rounded-tl-lg rounded-tr-lg;
      @apply flex items-end justify-between;
      @apply font-bold text-base text-secondary-100;
      width: 382px;
      height: 55px;
      .aha-tab-content {
        @apply h-full;
      }
      .aha-tab-title {
        padding-top: 15.5px;
        padding-bottom: 12.5px;
        margin-right: 2rem;
        &.active {
          border-bottom-width: 3px;
        }
      }
    }
  }
}
</style>
